// extracted by mini-css-extract-plugin
export default {"root":"badges_list-module___root___e400568d"};